export const KB_URL = 'https://help.mailship.eu'
export const MAILSHIP_CONTACT_URL = 'https://www.mailstep.cz/kontakt/'
export const FACEBOOK_LINK = 'https://cs-cz.facebook.com/mailstepfulfillment'
export const INSTAGRAM_LINK = 'https://www.instagram.com/mailstep_fulfillment'
export const LINKEDIN_LINK = 'https://cz.linkedin.com/company/mail-step'
export const TWITTER_LINK = 'https://twitter.com/mailstep'
export const EMAIL_ADDRESS = 'support@mailstep.cz'
